export default "__VITE_ASSET__DIB3U2sh__"